<template>
  <div>
    <div class="box box-info">
      <div class="box-header with-border">
        <div class="col-md-5">
          <h3 class="box-title">{{$t('reportLiabilitiesReport.detailsOfUnpaidByMonth')}}</h3>
        </div>
        <div class="col-md-7">
            <div class="col-md-12 col-sm-6 col-xs-12">
                <!-- Date range -->
                <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label>{{$t('reportLiabilitiesReport.startDate')}}</label>
                        <date-picker
                        @dp-change="changeDateTime($event)"
                        class="form-control"
                        v-model="start_datetime"
                        :config="optionsStart"
                        ></date-picker>
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label>{{$t('reportLiabilitiesReport.endDate')}}</label>
                        <date-picker
                        @dp-change="changeDateTime($event)"
                        class="form-control"
                        v-model="end_datetime"
                        :config="optionsEnd"
                        ></date-picker>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="box-body">
          <div class="col-md-12">
              <b-table style="white-space: nowrap;" responsive :busy="isLoading" :items="columnData" :fields="column_fields" class="mt-3" bordered outlined>
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{$t('reportLiabilitiesReport.loading')}}</strong>
                </div>
              </template>
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template slot="target" slot-scope="row">
                <a :href="row.item.url" target="_blank" :id="`segment_target_${row.item.id}`">{{row.item.target}}</a>
                <tooltip :text="row.item.url" :target="`#segment_target_${row.item.id}`"/>
              </template>
            </b-table>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from 'moment'
import utils from '@/lib/utils'

export default {
  name: "DetailedReportByEachMonth",
  props: {
    apartment_type: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
        columnData: [
        ],
        column_fields: [
            { key: 'Mã Căn', label: '', class: 'text-right' },
        ],
        optionsStart: {
            format: "MM/YYYY",
            useCurrent: false,
            maxDate: false
        },
        optionsEnd: {
            format: "MM/YYYY",
            useCurrent: true,
            minDate: false,
            maxDate: false
        },
        dateArray: [],
        dateFormat: null,
        apartmentType: 1,
        start_datetime: null,
        end_datetime: null,
        total: 0,
        totalAll: 0,
        isLoading: false,
    };
  },
  watch: {
    DETAILED_REPORT_BY_EACH_MONTH_DATA: function() {
      let apartment_monthly_total_fee = this.DETAILED_REPORT_BY_EACH_MONTH_DATA.data.apartment_monthly_total_fee
      let monthly_usage_total_fee = this.DETAILED_REPORT_BY_EACH_MONTH_DATA.data.monthly_usage_total_fee
      this.column_fields = []
      this.column_fields = [
        { key: 'Mã Căn', label: 'Mã Căn', class: 'text-right' },
      ],
      this.columnData = []
      for (let i = 0, size = apartment_monthly_total_fee.length; i < size; i++) {
        this.columnData.push({'Mã Căn': apartment_monthly_total_fee[i].apartment_code})
      }
      this.columnData.push({'Mã Căn': 'Tổng'})
      for (let i = 0, size = apartment_monthly_total_fee.length; i < size; i++) {
        for (var date_key in apartment_monthly_total_fee[i].apartment_total_fee_by_each_month) {
          if (apartment_monthly_total_fee[i].apartment_total_fee_by_each_month.hasOwnProperty(date_key)) {      
            this.column_fields.push({key: date_key, label: date_key, class: 'text-right'})
          }
        }
      }
      this.column_fields.push({key: 'Tổng', label: 'Tổng', class: 'text-right'})
      for (let i = 0, size = apartment_monthly_total_fee.length; i < size; i++) {
        this.total = 0
        for (var key in apartment_monthly_total_fee[i].apartment_total_fee_by_each_month) {
          if (apartment_monthly_total_fee[i].apartment_total_fee_by_each_month.hasOwnProperty(key)) {      
            this.columnData[i][key] = utils.convertFormatNumberToMoney(apartment_monthly_total_fee[i].apartment_total_fee_by_each_month[key])
            this.total += apartment_monthly_total_fee[i].apartment_total_fee_by_each_month[key]
          }
        }
        this.columnData[i]['Tổng'] = utils.convertFormatNumberToMoney(this.total)
      }
      this.totalAll = 0
      // Total in a month and total all month
      for (var totalKey in monthly_usage_total_fee) {
        if (monthly_usage_total_fee.hasOwnProperty(totalKey)) {      
          this.columnData[this.columnData.length - 1][totalKey] = utils.convertFormatNumberToMoney(monthly_usage_total_fee[totalKey])
          this.totalAll += monthly_usage_total_fee[totalKey]
        }
      }
      this.columnData[this.columnData.length - 1]['Tổng'] = utils.convertFormatNumberToMoney(this.totalAll)
      // Handle remove total is 0
      let newColumnData = []
      for (let j = 0, size = this.columnData.length; j < size; j++) {
        if (this.columnData[j]['Tổng'] != '0 VNĐ') {
          newColumnData.push(this.columnData[j])
        }
      }
      this.columnData = newColumnData
      this.isLoading = false
    }
  },
  computed: {
      ...mapGetters([
        "DETAILED_REPORT_BY_EACH_MONTH_DATA"
      ])
  },
  methods: {
    ...mapActions([
        "ERROR_TOAST",
        "SUCCESS_TOAST",
        "DETAILED_REPORT_BY_EACH_MONTH"
    ]),
    submit: function(apartmentType) {
      this.isLoading = true
      this.apartmentType = apartmentType
      let filter = {
        params: {
          dateArray: this.dateArray,
          dateFormat: this.dateFormat,
          apartmentType: this.apartmentType
        }
      }
      this.DETAILED_REPORT_BY_EACH_MONTH(filter).then(
        function(res) {
          // Todo
        }.bind(this)
      ).catch(
        function(error) {
          this.isLoading = false
        }
      )
    },
    getFormat: function () {
      if (utils.isNull(this.dateFormat)) {
        let dateFormat = ""
        let startDate = String(this.start_datetime)
        startDate.includes('/') ? dateFormat = 'MM/YYYY' : dateFormat = 'MM-YYYY'
        return dateFormat
      } else {
        return this.dateFormat
      }
    },
    changeDateTime: function(event) {
      this.isLoading = true
      if (this.end_datetime == undefined) {
        this.optionsEnd.minDate = moment(
          this.start_datetime,
          this.dateFormat
        );
      } else if (this.start_datetime == undefined) {
        this.optionsStart.maxDate = moment(
          this.end_datetime,
          this.dateFormat
        );
      } else {
        this.optionsStart.minDate = moment(this.end_datetime, this.getFormat()).subtract(11, 'months');
        this.optionsStart.maxDate = moment()
        this.optionsEnd.minDate = moment(this.start_datetime, this.getFormat());
        this.optionsEnd.maxDate = moment(this.start_datetime, this.getFormat()).add(11, 'months')
      }
      // Handle count liabilities apartment monthly usage
      this.dateArray = []
      let dateArray = utils.getDatesBetweenTwoDate(this.start_datetime, this.end_datetime, this.dateFormat)
      this.dateArray = dateArray
      if (this.dateArray.length > 0) {
        let filter = {
          params: {
            dateArray: this.dateArray,
            dateFormat: this.dateFormat,
            apartmentType: this.apartmentType
          }
        }
        this.DETAILED_REPORT_BY_EACH_MONTH(filter).then(
          function(res) {
            // Todo
          }.bind(this)
        ).catch(
          function(error) {
            this.isLoading = false
          }
        )
      }
    },
  },
  created() {
    let dateFormat = sessionStorage.getItem('projectDateViewOptions')
    if (!utils.isNull(dateFormat)) {
      this.isLoading = true
      this.dateFormat = dateFormat.slice(3)
      this.optionsStart.format = this.dateFormat
      this.optionsEnd.format = this.dateFormat
      if (this.dateArray.length <= 0) {
        this.dateArray.push(moment(new Date()).format(this.dateFormat))
      }
      if (this.apartment_type != 0) {
        this.apartmentType = this.apartment_type
        let filter = {
          params: {
            dateArray: this.dateArray,
            dateFormat: this.dateFormat,
            apartmentType: this.apartmentType
          }
        }
        this.DETAILED_REPORT_BY_EACH_MONTH(filter).then(
          function(res) {
            this.isLoading = false;
          }.bind(this)
        ).catch(
          function(error) {
            this.isLoading = false
          }
        )
      }
    }
  },
  mounted() {
    this.start_datetime = moment();
    this.end_datetime = moment();
  },
  components: {
    "date-picker": datePicker
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/views/Report/DetailedReportByEachMonth.vue